import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            探索内容板块
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            六大主题板块，满足不同情感交流需求，找到属于你的圈子
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300 flex-shrink-0">
                  <i className={`${cat.icon} text-lg`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-base font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 mb-2">
                    {cat.description}
                  </p>
                  <span className="text-xs text-foreground-400">
                    {cat.count.toLocaleString()} 篇内容
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}